export const BILL_INQUIRY_MCI: 9200 = 9200;
export const BILL_INQUIRY_MCI_RESPONSE: 39200 = 39200;
export const BILL_INQUIRY_TELECOM: 9201 = 9201;
export const BILL_INQUIRY_TELECOM_RESPONSE: 39201 = 39201;
export const CHANNEL_ADD_ADMIN: 402 = 402;
export const CHANNEL_ADD_ADMIN_RESPONSE: 30402 = 30402;
export const CHANNEL_ADD_MEMBER: 401 = 401;
export const CHANNEL_ADD_MEMBER_RESPONSE: 30401 = 30401;
export const CHANNEL_ADD_MESSAGE_REACTION: 424 = 424;
export const CHANNEL_ADD_MESSAGE_REACTION_RESPONSE: 30424 = 30424;
export const CHANNEL_ADD_MODERATOR: 403 = 403;
export const CHANNEL_ADD_MODERATOR_RESPONSE: 30403 = 30403;
export const CHANNEL_AVATAR_ADD: 412 = 412;
export const CHANNEL_AVATAR_ADD_RESPONSE: 30412 = 30412;
export const CHANNEL_AVATAR_DELETE: 413 = 413;
export const CHANNEL_AVATAR_DELETE_RESPONSE: 30413 = 30413;
export const CHANNEL_AVATAR_GET_LIST: 414 = 414;
export const CHANNEL_AVATAR_GET_LIST_RESPONSE: 30414 = 30414;
export const CHANNEL_CHECK_USERNAME: 418 = 418;
export const CHANNEL_CHECK_USERNAME_RESPONSE: 30418 = 30418;
export const CHANNEL_CREATE: 400 = 400;
export const CHANNEL_CREATE_RESPONSE: 30400 = 30400;
export const CHANNEL_DELETE: 404 = 404;
export const CHANNEL_DELETE_MESSAGE: 411 = 411;
export const CHANNEL_DELETE_MESSAGE_RESPONSE: 30411 = 30411;
export const CHANNEL_DELETE_RESPONSE: 30404 = 30404;
export const CHANNEL_EDIT: 405 = 405;
export const CHANNEL_EDIT_MESSAGE: 425 = 425;
export const CHANNEL_EDIT_MESSAGE_RESPONSE: 30425 = 30425;
export const CHANNEL_EDIT_RESPONSE: 30405 = 30405;
export const CHANNEL_GET_DRAFT: 416 = 416;
export const CHANNEL_GET_DRAFT_RESPONSE: 30416 = 30416;
export const CHANNEL_GET_MEMBER_LIST: 417 = 417;
export const CHANNEL_GET_MEMBER_LIST_RESPONSE: 30417 = 30417;
export const CHANNEL_GET_MESSAGES_STATS: 423 = 423;
export const CHANNEL_GET_MESSAGES_STATS_RESPONSE: 30423 = 30423;
export const CHANNEL_KICK_ADMIN: 406 = 406;
export const CHANNEL_KICK_ADMIN_RESPONSE: 30406 = 30406;
export const CHANNEL_KICK_MEMBER: 407 = 407;
export const CHANNEL_KICK_MEMBER_RESPONSE: 30407 = 30407;
export const CHANNEL_KICK_MODERATOR: 408 = 408;
export const CHANNEL_KICK_MODERATOR_RESPONSE: 30408 = 30408;
export const CHANNEL_LEFT: 409 = 409;
export const CHANNEL_LEFT_RESPONSE: 30409 = 30409;
export const CHANNEL_PIN_MESSAGE: 427 = 427;
export const CHANNEL_PIN_MESSAGE_RESPONSE: 30427 = 30427;
export const CHANNEL_REMOVE_USERNAME: 420 = 420;
export const CHANNEL_REMOVE_USERNAME_RESPONSE: 30420 = 30420;
export const CHANNEL_REVOKE_LINK: 421 = 421;
export const CHANNEL_REVOKE_LINK_RESPONSE: 30421 = 30421;
export const CHANNEL_SEND_MESSAGE: 410 = 410;
export const CHANNEL_SEND_MESSAGE_RESPONSE: 30410 = 30410;
export const CHANNEL_UPDATE_DRAFT: 415 = 415;
export const CHANNEL_UPDATE_DRAFT_RESPONSE: 30415 = 30415;
export const CHANNEL_UPDATE_REACTION_STATUS: 426 = 426;
export const CHANNEL_UPDATE_REACTION_STATUS_RESPONSE: 30426 = 30426;
export const CHANNEL_UPDATE_SIGNATURE: 422 = 422;
export const CHANNEL_UPDATE_SIGNATURE_RESPONSE: 30422 = 30422;
export const CHANNEL_UPDATE_USERNAME: 419 = 419;
export const CHANNEL_UPDATE_USERNAME_RESPONSE: 30419 = 30419;
export const CHAT_CLEAR_MESSAGE: 205 = 205;
export const CHAT_CLEAR_MESSAGE_RESPONSE: 30205 = 30205;
export const CHAT_CONVERT_TO_GROUP: 209 = 209;
export const CHAT_CONVERT_TO_GROUP_RESPONSE: 30209 = 30209;
export const CHAT_DELETE: 206 = 206;
export const CHAT_DELETE_MESSAGE: 204 = 204;
export const CHAT_DELETE_MESSAGE_RESPONSE: 30204 = 30204;
export const CHAT_DELETE_RESPONSE: 30206 = 30206;
export const CHAT_EDIT_MESSAGE: 203 = 203;
export const CHAT_EDIT_MESSAGE_RESPONSE: 30203 = 30203;
export const CHAT_GET_DRAFT: 208 = 208;
export const CHAT_GET_DRAFT_RESPONSE: 30208 = 30208;
export const CHAT_GET_ROOM: 200 = 200;
export const CHAT_GET_ROOM_RESPONSE: 30200 = 30200;
export const CHAT_SEND_MESSAGE: 201 = 201;
export const CHAT_SEND_MESSAGE_RESPONSE: 30201 = 30201;
export const CHAT_SET_ACTION: 210 = 210;
export const CHAT_SET_ACTION_RESPONSE: 30210 = 30210;
export const CHAT_UPDATE_DRAFT: 207 = 207;
export const CHAT_UPDATE_DRAFT_RESPONSE: 30207 = 30207;
export const CHAT_UPDATE_STATUS: 202 = 202;
export const CHAT_UPDATE_STATUS_RESPONSE: 30202 = 30202;
export const CLIENT_CHECK_INVITE_LINK: 607 = 607;
export const CLIENT_CHECK_INVITE_LINK_RESPONSE: 30607 = 30607;
export const CLIENT_CONDITION: 600 = 600;
export const CLIENT_CONDITION_RESPONSE: 30600 = 30600;
export const CLIENT_COUNT_ROOM_HISTORY: 613 = 613;
export const CLIENT_COUNT_ROOM_HISTORY_RESPONSE: 30613 = 30613;
export const CLIENT_GET_DISCOVERY: 620 = 620;
export const CLIENT_GET_DISCOVERY_RESPONSE: 30620 = 30620;
export const CLIENT_GET_FAVORITE_MENU: 619 = 619;
export const CLIENT_GET_FAVORITE_MENU_RESPONSE: 30619 = 30619;
export const CLIENT_GET_POLL: 624 = 624;
export const CLIENT_GET_POLL_RESPONSE: 30624 = 30624;
export const CLIENT_GET_PROMOTE: 618 = 618;
export const CLIENT_GET_PROMOTE_RESPONSE: 30618 = 30618;
export const CLIENT_GET_ROOM: 602 = 602;
export const CLIENT_GET_ROOM_HISTORY: 603 = 603;
export const CLIENT_GET_ROOM_HISTORY_RESPONSE: 30603 = 30603;
export const CLIENT_GET_ROOM_LIST: 601 = 601;
export const CLIENT_GET_ROOM_LIST_RESPONSE: 30601 = 30601;
export const CLIENT_GET_ROOM_MESSAGE: 604 = 604;
export const CLIENT_GET_ROOM_MESSAGE_RESPONSE: 30604 = 30604;
export const CLIENT_GET_ROOM_RESPONSE: 30602 = 30602;
export const CLIENT_JOIN_BY_INVITE_LINK: 608 = 608;
export const CLIENT_JOIN_BY_INVITE_LINK_RESPONSE: 30608 = 30608;
export const CLIENT_JOIN_BY_USERNAME: 609 = 609;
export const CLIENT_JOIN_BY_USERNAME_RESPONSE: 30609 = 30609;
export const CLIENT_MUTE_ROOM: 614 = 614;
export const CLIENT_MUTE_ROOM_RESPONSE: 30614 = 30614;
export const CLIENT_PIN_ROOM: 615 = 615;
export const CLIENT_PIN_ROOM_RESPONSE: 30615 = 30615;
export const CLIENT_REGISTER_DEVICE: 617 = 617;
export const CLIENT_REGISTER_DEVICE_RESPONSE: 30617 = 30617;
export const CLIENT_RESOLVE_USERNAME: 606 = 606;
export const CLIENT_RESOLVE_USERNAME_RESPONSE: 30606 = 30606;
export const CLIENT_ROOM_REPORT: 616 = 616;
export const CLIENT_ROOM_REPORT_RESPONSE: 30616 = 30616;
export const CLIENT_SEARCH_ROOM_HISTORY: 605 = 605;
export const CLIENT_SEARCH_ROOM_HISTORY_RESPONSE: 30605 = 30605;
export const CLIENT_SEARCH_USERNAME: 612 = 612;
export const CLIENT_SEARCH_USERNAME_RESPONSE: 30612 = 30612;
export const CLIENT_SET_DISCOVERY_ITEM_AGREEMENT: 623 = 623;
export const CLIENT_SET_DISCOVERY_ITEM_AGREEMENT_RESPONSE: 30623 = 30623;
export const CLIENT_SET_DISCOVERY_ITEM_CLICK: 621 = 621;
export const CLIENT_SET_DISCOVERY_ITEM_CLICK_RESPONSE: 30621 = 30621;
export const CLIENT_SET_POLL_ITEM_CLICK: 625 = 625;
export const CLIENT_SET_POLL_ITEM_CLICK_RESPONSE: 30625 = 30625;
export const CLIENT_SUBSCRIBE_TO_ROOM: 610 = 610;
export const CLIENT_SUBSCRIBE_TO_ROOM_RESPONSE: 30610 = 30610;
export const CLIENT_UNSUBSCRIBE_FROM_ROOM: 611 = 611;
export const CLIENT_UNSUBSCRIBE_FROM_ROOM_RESPONSE: 30611 = 30611;
export const CONNECTION_SECURING_RESPONSE: 30001 = 30001;
export const CONNECTION_SYMMETRIC_KEY: 2 = 2;
export const CONNECTION_SYMMETRIC_KEY_RESPONSE: 30002 = 30002;
export const ERROR_RESPONSE: 0 = 0;
export const FILE_DOWNLOAD: 705 = 705;
export const FILE_DOWNLOAD_RESPONSE: 30705 = 30705;
export const FILE_INFO: 704 = 704;
export const FILE_INFO_RESPONSE: 30704 = 30704;
export const FILE_UPLOAD: 702 = 702;
export const FILE_UPLOAD_INIT: 701 = 701;
export const FILE_UPLOAD_INIT_RESPONSE: 30701 = 30701;
export const FILE_UPLOAD_OPTION: 700 = 700;
export const FILE_UPLOAD_OPTION_RESPONSE: 30700 = 30700;
export const FILE_UPLOAD_RESPONSE: 30702 = 30702;
export const FILE_UPLOAD_STATUS: 703 = 703;
export const FILE_UPLOAD_STATUS_RESPONSE: 30703 = 30703;
export const GEO_GET_COMMENT: 1003 = 1003;
export const GEO_GET_COMMENT_RESPONSE: 31003 = 31003;
export const GEO_GET_CONFIGURATION: 1007 = 1007;
export const GEO_GET_CONFIGURATION_RESPONSE: 31007 = 31007;
export const GEO_GET_NEARBY_COORDINATE: 1006 = 1006;
export const GEO_GET_NEARBY_COORDINATE_RESPONSE: 31006 = 31006;
export const GEO_GET_NEARBY_DISTANCE: 1005 = 1005;
export const GEO_GET_NEARBY_DISTANCE_RESPONSE: 31005 = 31005;
export const GEO_GET_REGISTER_STATUS: 1000 = 1000;
export const GEO_GET_REGISTER_STATUS_RESPONSE: 31000 = 31000;
export const GEO_REGISTER: 1001 = 1001;
export const GEO_REGISTER_RESPONSE: 31001 = 31001;
export const GEO_UPDATE_COMMENT: 1004 = 1004;
export const GEO_UPDATE_COMMENT_RESPONSE: 31004 = 31004;
export const GEO_UPDATE_POSITION: 1002 = 1002;
export const GEO_UPDATE_POSITION_RESPONSE: 31002 = 31002;
export const GROUP_ADD_ADMIN: 302 = 302;
export const GROUP_ADD_ADMIN_RESPONSE: 30302 = 30302;
export const GROUP_ADD_MEMBER: 301 = 301;
export const GROUP_ADD_MEMBER_RESPONSE: 30301 = 30301;
export const GROUP_ADD_MODERATOR: 303 = 303;
export const GROUP_ADD_MODERATOR_RESPONSE: 30303 = 30303;
export const GROUP_AVATAR_ADD: 312 = 312;
export const GROUP_AVATAR_ADD_RESPONSE: 30312 = 30312;
export const GROUP_AVATAR_DELETE: 313 = 313;
export const GROUP_AVATAR_DELETE_RESPONSE: 30313 = 30313;
export const GROUP_AVATAR_GET_LIST: 314 = 314;
export const GROUP_AVATAR_GET_LIST_RESPONSE: 30314 = 30314;
export const GROUP_CHANGE_MEMBER_RIGHTS: 327 = 327;
export const GROUP_CHANGE_MEMBER_RIGHTS_RESPONSE: 30327 = 30327;
export const GROUP_CHECK_USERNAME: 321 = 321;
export const GROUP_CHECK_USERNAME_RESPONSE: 30321 = 30321;
export const GROUP_CLEAR_MESSAGE: 304 = 304;
export const GROUP_CLEAR_MESSAGE_RESPONSE: 30304 = 30304;
export const GROUP_CREATE: 300 = 300;
export const GROUP_CREATE_RESPONSE: 30300 = 30300;
export const GROUP_DELETE: 318 = 318;
export const GROUP_DELETE_MESSAGE: 320 = 320;
export const GROUP_DELETE_MESSAGE_RESPONSE: 30320 = 30320;
export const GROUP_DELETE_RESPONSE: 30318 = 30318;
export const GROUP_EDIT: 305 = 305;
export const GROUP_EDIT_MESSAGE: 325 = 325;
export const GROUP_EDIT_MESSAGE_RESPONSE: 30325 = 30325;
export const GROUP_EDIT_RESPONSE: 30305 = 30305;
export const GROUP_GET_DRAFT: 316 = 316;
export const GROUP_GET_DRAFT_RESPONSE: 30316 = 30316;
export const GROUP_GET_MEMBER_LIST: 317 = 317;
export const GROUP_GET_MEMBER_LIST_RESPONSE: 30317 = 30317;
export const GROUP_KICK_ADMIN: 306 = 306;
export const GROUP_KICK_ADMIN_RESPONSE: 30306 = 30306;
export const GROUP_KICK_MEMBER: 307 = 307;
export const GROUP_KICK_MEMBER_RESPONSE: 30307 = 30307;
export const GROUP_KICK_MODERATOR: 308 = 308;
export const GROUP_KICK_MODERATOR_RESPONSE: 30308 = 30308;
export const GROUP_LEFT: 309 = 309;
export const GROUP_LEFT_RESPONSE: 30309 = 30309;
export const GROUP_PIN_MESSAGE: 326 = 326;
export const GROUP_PIN_MESSAGE_RESPONSE: 30326 = 30326;
export const GROUP_REMOVE_USERNAME: 323 = 323;
export const GROUP_REMOVE_USERNAME_RESPONSE: 30323 = 30323;
export const GROUP_REVOKE_LINK: 324 = 324;
export const GROUP_REVOKE_LINK_RESPONSE: 30324 = 30324;
export const GROUP_SEND_MESSAGE: 310 = 310;
export const GROUP_SEND_MESSAGE_RESPONSE: 30310 = 30310;
export const GROUP_SET_ACTION: 319 = 319;
export const GROUP_SET_ACTION_RESPONSE: 30319 = 30319;
export const GROUP_UPDATE_DRAFT: 315 = 315;
export const GROUP_UPDATE_DRAFT_RESPONSE: 30315 = 30315;
export const GROUP_UPDATE_STATUS: 311 = 311;
export const GROUP_UPDATE_STATUS_RESPONSE: 30311 = 30311;
export const GROUP_UPDATE_USERNAME: 322 = 322;
export const GROUP_UPDATE_USERNAME_RESPONSE: 30322 = 30322;
export const HEARTBEAT: 3 = 3;
export const HEARTBEAT_RESPONSE: 30003 = 30003;
export const INFO_CONFIG: 506 = 506;
export const INFO_CONFIG_RESPONSE: 30506 = 30506;
export const INFO_COUNTRY: 501 = 501;
export const INFO_COUNTRY_RESPONSE: 30501 = 30501;
export const INFO_LOCATION: 500 = 500;
export const INFO_LOCATION_RESPONSE: 30500 = 30500;
export const INFO_PAGE: 503 = 503;
export const INFO_PAGE_RESPONSE: 30503 = 30503;
export const INFO_TIME: 502 = 502;
export const INFO_TIME_RESPONSE: 30502 = 30502;
export const INFO_WALLPAPER: 504 = 504;
export const INFO_WALLPAPER_RESPONSE: 30504 = 30504;
export const INFO_UPDATE: 505 = 505;
export const INFO_UPDATE_RESPONSE: 30505 = 30505;
export const MPL_GET_BILL_TOKEN: 9100 = 9100;
export const MPL_GET_BILL_TOKEN_RESPONSE: 39100 = 39100;
export const MPL_GET_SALES_TOKEN: 9102 = 9102;
export const MPL_GET_SALES_TOKEN_RESPONSE: 39102 = 39102;
export const MPL_GET_TOPUP_TOKEN: 9101 = 9101;
export const MPL_GET_TOPUP_TOKEN_RESPONSE: 39101 = 39101;
export const MPL_GET_TRANSACTION_LIST: 9109 = 9109;
export const MPL_GET_TRANSACTION_LIST_RESPONSE: 39109 = 39109;
export const MPL_GET_TRANSACTION_INFO: 9110 = 9110;
export const MPL_GET_TRANSACTION_INFO_RESPONSE: 39110 = 39110;
export const PUSH_LOGIN_TOKEN_RESPONSE: 60000 = 60000;
export const PUSH_RATE_SIGNALING_RESPONSE: 60003 = 60003;
export const PUSH_TWO_STEP_VERIFICATION_RESPONSE: 60001 = 60001;
export const PUSH_USER_INFO_EXPIRED_RESPONSE: 60002 = 60002;
export const PUSH_WALLET_PAYMENT_VERIFIED_RESPONSE: 60004 = 60004;
export const QR_CODE_ADD_CONTACT: 803 = 803;
export const QR_CODE_ADD_CONTACT_RESPONSE: 30803 = 30803;
export const QR_CODE_ADD_ME: 804 = 804;
export const QR_CODE_ADD_ME_RESPONSE: 30804 = 30804;
export const QR_CODE_JOIN: 800 = 800;
export const QR_CODE_JOIN_RESPONSE: 30800 = 30800;
export const QR_CODE_NEW_DEVICE: 802 = 802;
export const QR_CODE_NEW_DEVICE_RESPONSE: 30802 = 30802;
export const QR_CODE_RESOLVE: 801 = 801;
export const QR_CODE_RESOLVE_RESPONSE: 30801 = 30801;
export const SIGNALING_ACCEPT: 903 = 903;
export const SIGNALING_ACCEPT_RESPONSE: 30903 = 30903;
export const SIGNALING_CANDIDATE: 904 = 904;
export const SIGNALING_CANDIDATE_RESPONSE: 30904 = 30904;
export const SIGNALING_CLEAR_LOG: 908 = 908;
export const SIGNALING_CLEAR_LOG_RESPONSE: 30908 = 30908;
export const SIGNALING_GET_CONFIGURATION: 900 = 900;
export const SIGNALING_GET_CONFIGURATION_RESPONSE: 30900 = 30900;
export const SIGNALING_GET_LOG: 907 = 907;
export const SIGNALING_GET_LOG_RESPONSE: 30907 = 30907;
export const SIGNALING_LEAVE: 905 = 905;
export const SIGNALING_LEAVE_RESPONSE: 30905 = 30905;
export const SIGNALING_OFFER: 901 = 901;
export const SIGNALING_OFFER_RESPONSE: 30901 = 30901;
export const SIGNALING_RATE: 909 = 909;
export const SIGNALING_RATE_RESPONSE: 30909 = 30909;
export const SIGNALING_RINGING: 902 = 902;
export const SIGNALING_RINGING_RESPONSE: 30902 = 30902;
export const SIGNALING_SESSION_HOLD: 906 = 906;
export const SIGNALING_SESSION_HOLD_RESPONSE: 30906 = 30906;
export const USER_AVATAR_ADD: 114 = 114;
export const USER_AVATAR_ADD_RESPONSE: 30114 = 30114;
export const USER_AVATAR_DELETE: 115 = 115;
export const USER_AVATAR_DELETE_RESPONSE: 30115 = 30115;
export const USER_AVATAR_GET_LIST: 116 = 116;
export const USER_AVATAR_GET_LIST_RESPONSE: 30116 = 30116;
export const USER_CONTACTS_BLOCK: 128 = 128;
export const USER_CONTACTS_BLOCK_RESPONSE: 30128 = 30128;
export const USER_CONTACTS_DELETE: 108 = 108;
export const USER_CONTACTS_DELETE_RESPONSE: 30108 = 30108;
export const USER_CONTACTS_EDIT: 109 = 109;
export const USER_CONTACTS_EDIT_RESPONSE: 30109 = 30109;
export const USER_CONTACTS_GET_BLOCKED_LIST: 130 = 130;
export const USER_CONTACTS_GET_BLOCKED_LIST_RESPONSE: 30130 = 30130;
export const USER_CONTACTS_GET_LIST: 107 = 107;
export const USER_CONTACTS_GET_LIST_RESPONSE: 30107 = 30107;
export const USER_CONTACTS_IMPORT: 106 = 106;
export const USER_CONTACTS_IMPORT_RESPONSE: 30106 = 30106;
export const USER_CONTACTS_UNBLOCK: 129 = 129;
export const USER_CONTACTS_UNBLOCK_RESPONSE: 30129 = 30129;
export const USER_DELETE: 119 = 119;
export const USER_DELETE_RESPONSE: 30119 = 30119;
export const USER_GET_DELETE_TOKEN: 118 = 118;
export const USER_GET_DELETE_TOKEN_RESPONSE: 30118 = 30118;
export const USER_INFO: 117 = 117;
export const USER_INFO_RESPONSE: 30117 = 30117;
export const USER_IVAND_GET_ACTIVITIES: 153 = 153;
export const USER_IVAND_GET_ACTIVITIES_RESPONSE: 30153 = 30153;
export const USER_IVAND_GET_SCORE: 154 = 154;
export const USER_IVAND_GET_SCORE_RESPONSE: 30154 = 30154;
export const USER_IVAND_SET_ACTIVITY: 155 = 155;
export const USER_IVAND_SET_ACTIVITY_RESPONSE: 30155 = 30155;
export const USER_LOGIN: 102 = 102;
export const USER_LOGIN_RESPONSE: 30102 = 30102;
export const USER_PRIVACY_GET_RULE: 143 = 143;
export const USER_PRIVACY_GET_RULE_RESPONSE: 30143 = 30143;
export const USER_PRIVACY_SET_RULE: 144 = 144;
export const USER_PRIVACY_SET_RULE_RESPONSE: 30144 = 30144;
export const USER_PROFILE_CHECK_USERNAME: 122 = 122;
export const USER_PROFILE_CHECK_USERNAME_RESPONSE: 30122 = 30122;
export const USER_PROFILE_GET_BIO: 148 = 148;
export const USER_PROFILE_GET_BIO_RESPONSE: 30148 = 30148;
export const USER_PROFILE_GET_EMAIL: 110 = 110;
export const USER_PROFILE_GET_EMAIL_RESPONSE: 30110 = 30110;
export const USER_PROFILE_GET_GENDER: 111 = 111;
export const USER_PROFILE_GET_GENDER_RESPONSE: 30111 = 30111;
export const USER_PROFILE_GET_NICKNAME: 112 = 112;
export const USER_PROFILE_GET_NICKNAME_RESPONSE: 30112 = 30112;
export const USER_PROFILE_GET_REPRESENTATIVE: 151 = 151;
export const USER_PROFILE_GET_REPRESENTATIVE_RESPONSE: 30151 = 30151;
export const USER_PROFILE_GET_SELF_REMOVE: 121 = 121;
export const USER_PROFILE_GET_SELF_REMOVE_RESPONSE: 30121 = 30121;
export const USER_PROFILE_SET_BIO: 147 = 147;
export const USER_PROFILE_SET_BIO_RESPONSE: 30147 = 30147;
export const USER_PROFILE_SET_EMAIL: 103 = 103;
export const USER_PROFILE_SET_EMAIL_RESPONSE: 30103 = 30103;
export const USER_PROFILE_SET_GENDER: 104 = 104;
export const USER_PROFILE_SET_GENDER_RESPONSE: 30104 = 30104;
export const USER_PROFILE_SET_NICKNAME: 105 = 105;
export const USER_PROFILE_SET_NICKNAME_RESPONSE: 30105 = 30105;
export const USER_PROFILE_SET_REPRESENTATIVE: 152 = 152;
export const USER_PROFILE_SET_REPRESENTATIVE_RESPONSE: 30152 = 30152;
export const USER_PROFILE_SET_SELF_REMOVE: 120 = 120;
export const USER_PROFILE_SET_SELF_REMOVE_RESPONSE: 30120 = 30120;
export const USER_PROFILE_UPDATE_USERNAME: 123 = 123;
export const USER_PROFILE_UPDATE_USERNAME_RESPONSE: 30123 = 30123;
export const USER_REGISTER: 100 = 100;
export const USER_REGISTER_RESPONSE: 30100 = 30100;
export const USER_REPORT: 149 = 149;
export const USER_REPORT_RESPONSE: 30149 = 30149;
export const USER_SESSION_GET_ACTIVE_LIST: 125 = 125;
export const USER_SESSION_GET_ACTIVE_LIST_RESPONSE: 30125 = 30125;
export const USER_SESSION_LOGOUT: 127 = 127;
export const USER_SESSION_LOGOUT_RESPONSE: 30127 = 30127;
export const USER_SESSION_TERMINATE: 126 = 126;
export const USER_SESSION_TERMINATE_RESPONSE: 30126 = 30126;
export const USER_SET_BOT: 150 = 150;
export const USER_SET_BOT_RESPONSE: 30150 = 30150;
export const USER_TWO_STEP_VERIFICATION_CHANGE_HINT: 142 = 142;
export const USER_TWO_STEP_VERIFICATION_CHANGE_HINT_RESPONSE: 30142 = 30142;
export const USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_EMAIL: 137 = 137;
export const USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_EMAIL_RESPONSE: 30137 = 30137;
export const USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_QUESTION: 141 = 141;
export const USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_QUESTION_RESPONSE: 30141 = 30141;
export const USER_TWO_STEP_VERIFICATION_CHECK_PASSWORD: 135 = 135;
export const USER_TWO_STEP_VERIFICATION_CHECK_PASSWORD_RESPONSE: 30135 = 30135;
export const USER_TWO_STEP_VERIFICATION_GET_PASSWORD_DETAIL: 131 = 131;
export const USER_TWO_STEP_VERIFICATION_GET_PASSWORD_DETAIL_RESPONSE: 30131 = 30131;
export const USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_ANSWERS: 140 = 140;
export const USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_ANSWERS_RESPONSE: 30140 = 30140;
export const USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_TOKEN: 139 = 139;
export const USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_TOKEN_RESPONSE: 30139 = 30139;
export const USER_TWO_STEP_VERIFICATION_REQUEST_RECOVERY_TOKEN: 138 = 138;
export const USER_TWO_STEP_VERIFICATION_REQUEST_RECOVERY_TOKEN_RESPONSE: 30138 = 30138;
export const USER_TWO_STEP_VERIFICATION_RESEND_VERIFY_EMAIL: 146 = 146;
export const USER_TWO_STEP_VERIFICATION_RESEND_VERIFY_EMAIL_RESPONSE: 30146 = 30146;
export const USER_TWO_STEP_VERIFICATION_SET_PASSWORD: 133 = 133;
export const USER_TWO_STEP_VERIFICATION_SET_PASSWORD_RESPONSE: 30133 = 30133;
export const USER_TWO_STEP_VERIFICATION_UNSET_PASSWORD: 134 = 134;
export const USER_TWO_STEP_VERIFICATION_UNSET_PASSWORD_RESPONSE: 30134 = 30134;
export const USER_TWO_STEP_VERIFICATION_VERIFY_PASSWORD: 132 = 132;
export const USER_TWO_STEP_VERIFICATION_VERIFY_PASSWORD_RESPONSE: 30132 = 30132;
export const USER_TWO_STEP_VERIFICATION_VERIFY_RECOVERY_EMAIL: 136 = 136;
export const USER_TWO_STEP_VERIFICATION_VERIFY_RECOVERY_EMAIL_RESPONSE: 30136 = 30136;
export const USER_UPDATE_STATUS: 124 = 124;
export const USER_UPDATE_STATUS_RESPONSE: 30124 = 30124;
export const USER_USERNAME_TO_ID: 113 = 113;
export const USER_USERNAME_TO_ID_RESPONSE: 30113 = 30113;
export const USER_VERIFY: 101 = 101;
export const USER_VERIFY_NEW_DEVICE: 145 = 145;
export const USER_VERIFY_NEW_DEVICE_RESPONSE: 30145 = 30145;
export const USER_VERIFY_RESPONSE: 30101 = 30101;
export const WALLET_GET_ACCESS_TOKEN: 9000 = 9000;
export const WALLET_GET_ACCESS_TOKEN_RESPONSE: 39000 = 39000;
export const WALLET_ID_MAPPING: 9003 = 9003;
export const WALLET_ID_MAPPING_RESPONSE: 39003 = 39003;
export const WALLET_PAYMENT_INIT: 9001 = 9001;
export const WALLET_PAYMENT_INIT_RESPONSE: 39001 = 39001;
export const WALLET_REGISTER: 9002 = 9002;
export const WALLET_REGISTER_RESPONSE: 39002 = 39002;
export const STORY_GET_STORIES: 1203 = 1203;
export const STORY_GET_STORIES_RESPONSE: 31203 = 31203;
export const STORY_ADD_STORIES: 1201 = 1201;
export const STORY_ADD_STORIES_RESPONSE: 31201 = 31201;
export const STORY_ADD_VIEW: 1204 = 1204;
export const STORY_ADD_VIEW_RESPONSE: 31204 = 31204;
export const STORY_GET_OWN_STORY_VIEWS: 1205 = 1205;
export const STORY_GET_OWN_STORY_VIEWS_RESPONSE: 31205 = 31205;
export const STORY_DELETE_STORY: 1206 = 1206;
export const STORY_DELETE_STORY_RESPONSE: 31206 = 31206;
export const CLIENT_ROOM_CHANGE_OWNER: 626 = 626;
export const CLIENT_ROOM_CHANGE_OWNER_RESPONSE: 30626 = 30626;
export const CLIENT_SEARCH: 627 = 627;
export const CLIENT_SEARCH_RESPONSE: 30627 = 30627;

export const USER_CHANGE_PHONE_NUMBER: 162 = 162;
export const USER_CHANGE_PHONE_NUMBER_RESPONSE: 30162 = 30162;
export const USER_VERIFY_NEW_PHONE_NUMBER: 163 = 163;
export const USER_VERIFY_NEW_PHONE_NUMBER_RESPONSE: 30163 = 30163;

export const GROUP_ROOM_MEMBER_MENTION = 328;
export const GROUP_ROOM_MEMBER_MENTION_RESPONSE = 30328;
export const CLIENT_ROOM_MEMBER_SEARCH = 628;
export const CLIENT_ROOM_MEMBER_SEARCH_RESPONSE = 30628;
